import { Col, Form, Row, Select } from "antd";
import { FormInstance } from "antd/lib/form";
import React from "react";
import { useParams } from "react-router";

type FormType = {
  form: FormInstance<any>;
  values?: any;
  handler: (values: any) => void;
  data: any;
};

export const UserBrandForm: React.FC<FormType> = (props) => {
  const { form, values, handler, data } = props;
  const { userId } = useParams();

  const {
    collectionBrands: { nodes: collectionBrands },
    accountUsers: { nodes: accountUsers },
  } = data;

  const users: any[] = [];
  const salespersons: any[] = [];
  accountUsers.forEach((user: any) => {
    if (user.role === "USER") users.push(user);
    else if (user.role === "SALESPERSON") salespersons.push(user);
  });

  return (
    <Form layout="vertical" form={form} initialValues={values} onFinish={handler}>
      <Row gutter={[24, 0]}>
        <Col span={8}>
          <Form.Item name="userId" label="User" rules={[{ required: true, message: "is required" }]}>
            <Select
              disabled={userId ? true : false}
              showSearch
              filterOption={(input: string, option: any) => {
                return option.children.join("").toLowerCase().indexOf(input.toLowerCase()) >= 0;
              }}
            >
              {users.map((user: any) => (
                <Select.Option key={user.id} value={user.id}>
                  {user.code} - {user.email}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="brandId" label="Brand" rules={[{ required: true, message: "is required" }]}>
            <Select>
              {collectionBrands.map((brand: any) => (
                <Select.Option key={brand.id} value={brand.id}>
                  {brand.code}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="salespersonId" label="Salesperson">
            <Select
              allowClear
              showSearch
              filterOption={(input: string, option: any) => {
                return option.children.join("").toLowerCase().indexOf(input.toLowerCase()) >= 0;
              }}
            >
              {salespersons.map((user: any) => (
                <Select.Option key={user.id} value={user.id}>
                  {user.code} - {user.email}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
